import type { ListeTableFilterData } from '@mairistem/liste';
import React from 'react';

import type { RecuEncaissementType } from '@/types';

export type RecuContextType = {
  total: number;
  recus: RecuEncaissementType[];
  filters: ListeTableFilterData[];
  search: string;
  sorts: Record<string, 'asc' | 'desc'>;

  setRecus: React.Dispatch<React.SetStateAction<RecuEncaissementType[]>>;
  setFilters: React.Dispatch<React.SetStateAction<ListeTableFilterData[]>>;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setSorts: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setTotal: React.Dispatch<React.SetStateAction<number>>;
  applyDefaultFilters: () => void;
  getRecus: () => void;
  onRecuCancel: (recu: RecuEncaissementType) => Promise<RecuEncaissementType>;
  /** Rejet du prélèvement en ligne (PRI) d'un reçu : déclaré à MFO, reçu annulé. */
  onRecuReject: (
    recu: RecuEncaissementType,
    rejet: { motifRejet: string; dateLimitePaiement: string | null },
  ) => Promise<RecuEncaissementType>;
};

const RecuContext = React.createContext<RecuContextType>({
  total: 0,
  recus: [],
  filters: [],
  search: '',
  sorts: {},
  setRecus: () => {},
  setFilters: () => {},
  setSearch: () => {},
  setSorts: () => {},
  setPage: () => {},
  setTotal: () => {},
  applyDefaultFilters: () => {},
  getRecus: () => {},
  onRecuCancel: () => Promise.resolve(null),
  onRecuReject: () => Promise.resolve(null),
});

export default RecuContext;
